import { Controller } from "@hotwired/stimulus"

// Enables the submit button when the user types "DELETE" in the confirmation input.
// Used for large batch deletions (> 5,000 staged records).
export default class extends Controller {
  static targets = ["input", "submit"]

  connect() {
    this.check()
  }

  check() {
    if (!this.hasInputTarget || !this.hasSubmitTarget) return
    const matches = this.inputTarget.value.trim() === "DELETE"
    this.submitTarget.disabled = !matches
  }
}
